// src/App.tsx
import React from "react";
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from "react-router-dom";
import DynastyTradeCalculator from "./TradeCalculator";
import Rankings from "./Rankings";

// Navigation Component with Active State
function Nav() {
  const location = useLocation();
  const isCalculator = location.pathname === "/";
  const isRankings = location.pathname === "/rankings";

  return (
    <nav style={{
      maxWidth: "1400px",
      margin: "0 auto 40px",
      display: "flex",
      justifyContent: "center",
      gap: "24px",
      padding: "16px",
      backgroundColor: "rgba(255,255,255,0.92)",
      borderRadius: "20px",
      boxShadow: "0 8px 32px rgba(255,138,101,0.15)",
      backdropFilter: "blur(12px)",
      border: "1px solid rgba(255,255,255,0.3)",
      flexWrap: "wrap",
    }}>
      <Link
        to="/"
        style={{
          fontSize: "18px",
          fontWeight: 700,
          color: isCalculator ? "#ff8a65" : "#546e7a",
          textDecoration: "none",
          padding: "12px 28px",
          borderRadius: "14px",
          backgroundColor: isCalculator ? "white" : "transparent",
          boxShadow: isCalculator ? "0 4px 16px rgba(0,0,0,0.1)" : "none",
          transition: "all 0.2s",
        }}
      >
        Trade Calculator
      </Link>
      <Link
        to="/rankings"
        style={{
          fontSize: "18px",
          fontWeight: 700,
          color: isRankings ? "#26a69a" : "#546e7a",
          textDecoration: "none",
          padding: "12px 28px",
          borderRadius: "14px",
          backgroundColor: isRankings ? "white" : "transparent",
          boxShadow: isRankings ? "0 4px 16px rgba(0,0,0,0.1)" : "none",
          transition: "all 0.2s",
        }}
      >
        Player Rankings
      </Link>
    </nav>
  );
}

// Main App with Router
export default function App() {
  return (
    <Router>
      <div style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #fff5f0 0%, #ffe8dc 50%, #ffd6c8 100%)",
        padding: "32px 16px",
        boxSizing: "border-box",
        position: "relative",
      }}>
        {/* Background Decorations */}
        <div style={{
          position: "absolute",
          top: "10%",
          right: "5%",
          width: "300px",
          height: "300px",
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(255, 138, 101, 0.15) 0%, transparent 70%)",
          pointerEvents: "none",
        }}></div>
        <div style={{
          position: "absolute",
          bottom: "10%",
          left: "5%",
          width: "250px",
          height: "250px",
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(38, 166, 154, 0.15) 0%, transparent 70%)",
          pointerEvents: "none",
        }}></div>

        {/* Navigation */}
        <Nav />

        {/* Routes */}
        <Routes>
          <Route path="/" element={<DynastyTradeCalculator />} />
          <Route path="/rankings" element={<Rankings />} />
        </Routes>
      </div>
    </Router>
  );
}
